module.exports = __webpack_public_path__ + "static/media/click-here-button.17010fc8.png";